import { defineComponent as _defineComponent } from 'vue'
import { getAuthorDisplayName } from '@@/bits/author'
import device from '@@/bits/device'
import { getPostPublishedAt } from '@@/bits/post_timestamps'
import { blankUser, isRegistered as isUserRegistered } from '@@/bits/user_model'
import OzRelativeTime from '@@/library/v4/components/OzRelativeTime.vue'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfaceUserContributorsStore } from '@@/pinia/surface_user_contributors'
import type { HashId, Id } from '@@/types'
import { type Post, type User } from '@@/types'
import AvatarImage from '@@/vuecomponents/avatar_image.vue'
import emitClickOnTouch from '@@/vuedirectives/emit_click_on_touch'
import { storeToRefs } from 'pinia'
import { computed, onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostAuthor',
  props: {
    post: null
  },
  setup(__props: any) {

const props = __props as {
  post: Post
}

const vEmitClickOnTouch = emitClickOnTouch



const surfaceStore = useSurfaceStore()
const { colorScheme } = storeToRefs(surfaceStore)

const surfaceUserContributorsStore = useSurfaceUserContributorsStore()
const { fetchUser, getUserById } = surfaceUserContributorsStore

const authorId = computed<Id | HashId | undefined>(() => props.post.author_hashid || props.post.author_id)

const author = computed<User>(() => {
  if (!authorId.value) return blankUser()
  return getUserById(authorId.value) || blankUser()
})

const authorName = computed<string>(() => {
  return getAuthorDisplayName(author.value)
})

const authorProfileUrl = computed<string>(() => {
  return author.value.profile_url || ''
})

const isRegistered = computed<boolean>(() => {
  return isUserRegistered(author.value)
})

const publishedAt = computed<string | Date>(() => {
  return getPostPublishedAt(props.post)
})

onMounted((): void => {
  if (!authorId.value) return
  fetchUser(authorId.value)
})

return { __sfc: true,vEmitClickOnTouch, props, surfaceStore, colorScheme, surfaceUserContributorsStore, fetchUser, getUserById, authorId, author, authorName, authorProfileUrl, isRegistered, publishedAt, device, OzRelativeTime, AvatarImage }
}

})